import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'

export const TagStyles = StyleSheet.create({
	container: {
		width: 'auto',
		paddingVertical: 2,
		paddingHorizontal: 4,
		borderRadius: ThemedValues.borderRadius,
		borderWidth: 2,
		borderColor: 'darkgrey',
		backgroundColor: 'grey',
		opacity: 0.8,
		justifyContent: 'center'
	},
	
	text_light: {
		color: 'white',
		textAlign: 'center'
	},
	text_dark: {
		color: 'black',
		textAlign: 'center'
	}
});
